export const API_URL = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_VERSION;
// export const API_URL = 'https://api.ticketbox.mu/v2';

// export const API_URL = 'http://192.168.18.136:3002/v2';
export const BASE_URL = process.env.VUE_APP_BASE_URL;
